
export const pill = (bg, color = "#fff") => ({
  background: bg,
  color,
  borderRadius: 999,
  padding: "10px 16px",
  fontWeight: 700,
  fontSize: 14,
  letterSpacing: 1,
});
